(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  const drawerRoot = () => document.querySelector('#CartDrawer')
  let cartCloseTimer = null

  document.addEventListener('keydown', event => {
    const drawer = drawerRoot()
    if (event.key !== 'Tab' || !drawer?.open) return
    const controls = Array.from(drawer.querySelectorAll('a[href], button, input, select, textarea, [tabindex]'))
      .filter(element => !element.disabled && element.tabIndex >= 0 && element.getClientRects().length && !element.closest('[hidden], [inert]'))
    if (!controls.length) { event.preventDefault(); drawer.focus(); return }
    const first = controls[0]
    const last = controls[controls.length - 1]
    const active = document.activeElement
    if (event.shiftKey && (active === first || active === drawer || !drawer.contains(active))) {
      event.preventDefault(); last.focus()
    } else if (!event.shiftKey && (active === last || active === drawer || !drawer.contains(active))) {
      event.preventDefault(); first.focus()
    }
  })

  const openCartDrawer = (drawer = drawerRoot()) => {
    if (!drawer) return

    window.clearTimeout(cartCloseTimer)
    drawer.classList.remove('is-closing')

    if (!drawer.open) {
      drawer.showModal()
      drawer.focus({ preventScroll: true })
      drawer.scrollLeft = 0
    }

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        if (!drawer.open || drawer.classList.contains('is-closing')) return
        drawer.classList.add('is-visible')
      })
    })

    document.body.classList.add('cart-is-open')
  }

  const closeCartDrawer = (drawer = drawerRoot()) => {
    if (
      !drawer ||
      !drawer.open ||
      drawer.classList.contains('is-closing')
    ) {
      return
    }

    drawer.classList.add('is-closing')
    drawer.classList.remove('is-visible')
    document.body.classList.remove('cart-is-open')

    cartCloseTimer = window.setTimeout(() => {
      if (drawer.open) {
        drawer.close()
      }

      drawer.classList.remove('is-closing')
    }, window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : (window.matchMedia('(max-width: 749px)').matches ? 800 : 350))
  }

  const renderDrawer = (html, open = true) => {
    if (!html) {
      throw new Error((window.LoncryText ? window.LoncryText("theme_strings.s805fb6f47717", "Cart drawer section was not returned") : "Cart drawer section was not returned"))
    }

    const currentDrawer = drawerRoot()
    const currentPanel =
      currentDrawer?.querySelector('.cart-drawer__panel')
    const currentScroll =
      currentDrawer?.querySelector('.cart-drawer__scroll')
    const previousScrollTop = currentScroll?.scrollTop || 0

    const parsed = new DOMParser().parseFromString(
      html,
      'text/html'
    )

    const replacementPanel = parsed.querySelector(
      '#CartDrawer .cart-drawer__panel'
    )

    if (!currentPanel || !replacementPanel) {
      throw new Error((window.LoncryText ? window.LoncryText("theme_strings.sb6c11414146e", "Cart drawer panel was not found") : "Cart drawer panel was not found"))
    }

    currentPanel.replaceWith(replacementPanel)
    const count = Number(
  replacementPanel.querySelector('.cart-drawer__header > span')?.textContent.trim()
)

if (Number.isFinite(count)) {
  document.querySelectorAll('[data-cart-open]').forEach((cartLink) => {
    const badge = cartLink.querySelector('.header-cart-count')

    if (badge) {
      badge.textContent = String(count)
      badge.classList.toggle('is-empty', count === 0)
    }

    cartLink.setAttribute('aria-label', window.LoncryFormat ? window.LoncryFormat('theme_dynamic.cart_items', {count:count}, 'Cart') : `Cart, ${count} items`)
  })
}

    const updatedDrawer = drawerRoot()
    const updatedScroll = updatedDrawer?.querySelector(
      '.cart-drawer__scroll'
    )

    if (updatedScroll) {
      updatedScroll.scrollTop = previousScrollTop
    }

    if (open && updatedDrawer && !updatedDrawer.open) {
      openCartDrawer(updatedDrawer)
    }
  }

  let cartMutationTail = Promise.resolve()
  let cartMutationPending = 0
  const cartDisabled = new Map()
  const pendingCartForms = new WeakSet()
  const cartPath = () => window.Shopify?.routes?.root || '/'
  const updateCartBusy = () => {
    const busy = cartMutationPending > 0
    document.querySelectorAll('[data-drawer-quantity], [data-cart-clear], form[action*="/cart/add"] [type="submit"], [data-sticky-submit]').forEach(button => {
      if (busy) {
        if (!cartDisabled.has(button)) cartDisabled.set(button, button.disabled)
        button.disabled = true
      } else if (cartDisabled.has(button)) {
        const option = (button.form || button.closest('form'))?.querySelector('[data-variant-select]')?.selectedOptions[0]
        button.disabled = option?.dataset.available !== undefined
          ? option.dataset.available !== 'true'
          : cartDisabled.get(button)
        cartDisabled.delete(button)
      }
    })
    drawerRoot()?.setAttribute('aria-busy', String(busy))
    if (!busy) cartDisabled.clear()
  }
  document.addEventListener('change', event => {
    if (!cartMutationPending || !event.target.matches('[data-variant-select]')) return
    updateCartBusy()
  })
  const enqueueCartMutation = task => {
    const guard = window.LoncryCommerce
    const token = guard?.begin('cart-mutation')
    if (guard && !token) return Promise.resolve()
    cartMutationPending++
    updateCartBusy()
    const run = cartMutationTail.then(task)
    cartMutationTail = run.catch(() => {})
    return run.finally(() => {
      cartMutationPending--
      try { updateCartBusy() }
      finally { guard?.end(token) }
    })
  }
  const showCartError = (host, message, added = false) => {
    if (!host || !host.isConnected) host = drawerRoot()?.querySelector('.cart-drawer__panel')
    if (!host) return
    let error = host.querySelector('[data-loncry-cart-error]')
    if (!error) {
      error = document.createElement('p')
      error.dataset.loncryCartError = ''
      error.className = 'loncry-cart-error'
      error.setAttribute('role', 'alert')
      host.prepend(error)
    }
    error.replaceChildren(document.createTextNode(String(message)))
    if (added) {
      const link = document.createElement('a')
      link.href = cartPath() + 'cart'
      link.textContent = (window.LoncryText ? window.LoncryText("theme_strings.sdd1f6fec7949", " View bag") : " View bag")
      error.append(link)
    }
    error.hidden = false
  }
  const clearCartError = host => {
    const error = host?.querySelector('[data-loncry-cart-error]')
    if (error) { error.hidden = true; error.textContent = '' }
  }
  const refreshCartDrawer = async (html, open) => {
    try { renderDrawer(html, open) }
    catch (originalError) {
      // Recover rendering only. Never repeat the successful cart mutation.
      const response = await fetch(cartPath() + 'cart?section_id=cart-drawer', { headers: { Accept: 'text/html' } })
      if (!response.ok) throw originalError
      renderDrawer(await response.text(), open)
    }
    updateCartBusy()
  }

  document.addEventListener('click', async (event) => {
    const clearButton = event.target.closest('[data-cart-clear]')
    const quantityButton = event.target.closest('[data-drawer-quantity]')
    if (event.target.closest('[data-cart-open]')) { event.preventDefault(); openCartDrawer() }
    if (event.target.closest('[data-cart-close]')) { event.preventDefault(); closeCartDrawer() }
    if (event.target.matches('#CartDrawer')) closeCartDrawer(event.target)
    if (!clearButton && !quantityButton) return
    event.preventDefault()
    if (cartMutationPending || window.LoncryCommerce?.isBusy() || (clearButton || quantityButton).disabled) return
    const key = quantityButton?.dataset.drawerKey
    const quantity = Number(quantityButton?.dataset.drawerQuantity)
    if (quantityButton && (!key || !Number.isInteger(quantity) || quantity < 0)) return
    clearCartError(drawerRoot())
    let committed = false
    try {
      await enqueueCartMutation(async () => {
        const body = { sections: ['cart-drawer'], sections_url: window.location.pathname }
        if (quantityButton) { body.id = key; body.quantity = quantity }
        const response = await fetch(cartPath() + (clearButton ? 'cart/clear.js' : 'cart/change.js'), {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
        })
        const cart = await response.json()
        if (!response.ok) throw new Error(cart.description || (window.LoncryText ? window.LoncryText("theme_strings.sb10f659cffa5", "Unable to update your bag. Please try again.") : "Unable to update your bag. Please try again."))
        committed = true
        await refreshCartDrawer(cart.sections?.['cart-drawer'], true)
      })
    } catch (error) {
      showCartError(drawerRoot()?.querySelector('.cart-drawer__panel'), committed
        ? (window.LoncryText ? window.LoncryText("theme_strings.s9e2b13d29353", "Your bag was updated, but it could not be displayed. Please view your bag before making another change.") : "Your bag was updated, but it could not be displayed. Please view your bag before making another change.")
        : error.message || (window.LoncryText ? window.LoncryText("theme_strings.sb10f659cffa5", "Unable to update your bag. Please try again.") : "Unable to update your bag. Please try again."), committed)
    }
  })

  document.addEventListener(
    'cancel',
    (event) => {
      if (!event.target.matches('#CartDrawer')) return

      event.preventDefault()
      closeCartDrawer(event.target)
    },
    true
  )

  // Keep the existing AJAX add flow and single request per submission.
  document.addEventListener('submit', async (event) => {
    const form = event.target
    if (!form.matches('form[action*="/cart/add"]')) return
    event.preventDefault()
    if (pendingCartForms.has(form) || window.LoncryCommerce?.isBusy()) return
    pendingCartForms.add(form)
    const errorHost = form.closest('.loncry-buybox') || form
    clearCartError(errorHost)
    const formData = new FormData(form)
    formData.set('sections', 'cart-drawer')
    formData.set('sections_url', window.location.pathname)
    let committed = false
    try {
      await enqueueCartMutation(async () => {
        const response = await fetch(cartPath() + 'cart/add.js', {
          method: 'POST', body: formData, headers: { Accept: 'application/json' }
        })
        const result = await response.json()
        if (!response.ok) throw new Error(result.description || (window.LoncryText ? window.LoncryText("theme_strings.sed5addfc5256", "Unable to add this item. Please try again.") : "Unable to add this item. Please try again."))
        committed = true
        await refreshCartDrawer(result.sections?.['cart-drawer'], false)
      })
    } catch (error) {
      showCartError(errorHost, committed
        ? (window.LoncryText ? window.LoncryText("theme_strings.s1e87b21a00c1", "Item added to your bag, but the bag could not refresh. Please view your bag before adding again.") : "Item added to your bag, but the bag could not refresh. Please view your bag before adding again.")
        : error.message || (window.LoncryText ? window.LoncryText("theme_strings.sed5addfc5256", "Unable to add this item. Please try again.") : "Unable to add this item. Please try again."), committed)
    } finally {
      pendingCartForms.delete(form)
    }
  }, true)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-cart-quantity]')
    if (!button) return
    if (button.disabled || document.documentElement.dataset.cartUpdating === 'true') return
    const guard = window.LoncryCommerce
    const token = guard?.begin('cart-quantity')
    if (guard && !token) return
    document.documentElement.dataset.cartUpdating = 'true'
    button.disabled = true
    try {
    const response = await fetch(`${window.Shopify.routes.root}cart/change.js`, {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({id: button.dataset.line, quantity: Number(button.dataset.cartQuantity)})
    })
    if (!response.ok) throw new Error((window.LoncryText ? window.LoncryText("theme_strings.s89fae646089e", "Unable to update cart") : "Unable to update cart"))
    guard?.navigation(token)
    window.location.reload()
    } catch (error) {
      guard?.end(token)
      document.documentElement.dataset.cartUpdating = 'false'
      button.disabled = false
      window.alert((window.LoncryText ? window.LoncryText("theme_strings.sb10f659cffa5", "Unable to update your bag. Please try again.") : "Unable to update your bag. Please try again."))
    }
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  document.querySelectorAll('.collection-sort select').forEach((select) => {
    select.addEventListener('change', () => select.form.submit())
  })

  } catch(e) { console.error(e); }
})();
})();
